import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  };

  const currentLang = i18n.language;

  return (
    <>
      <style>
        {`
          /* Animation for the Tooltip Background */
          @keyframes gradientMove {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }

          .language-switcher {
            position: fixed;
            bottom: 20px;
            right: 0px;
            background-color: #ffffff;
            border-radius: 40px;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
            padding: 8px 16px;
            display: flex;
            align-items: center;
            z-index: 1000;
            font-family: sans-serif;
            border: 1px solid #eee;
          }

          /* --- The Animated Tooltip --- */
          .language-switcher::before {
            content: "Choose your language / اختر اللغة";
            position: absolute;
            bottom: 140%; 
            right: 50%;
            transform: translateX(50%) scale(0.8);
            
            /* Animated Gradient Background */
            background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
            background-size: 400% 400%;
            animation: gradientMove 5s ease infinite;
            
            color: white;
            padding: 0px 1px;
            border-radius: 12px;
            font-size: 14px;
            font-weight: bold;
            white-space: nowrap;
            opacity: 0;
            visibility: hidden;
            transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
            box-shadow: 0 10px 20px rgba(0,0,0,0.2);
          }

          /* Show Tooltip on Hover */
          .language-switcher:hover::before {
            opacity: 1;
            visibility: visible;
            transform: translateX(50%) scale(1);
          }

          /* --- Button Styles --- */
          .language-button {
            display: flex;
            align-items: center;
            border: none;
            background: transparent;
            font-size: 15px;
            cursor: pointer;
            padding:5px 5px;
            border-radius: 20px;
            transition: 0.3s;
            color: #333;
          }

          .language-button:hover {
            background-color: #f0f0f0;
          }

          .language-button.active {
            background-color: #f0f0f0;
            font-weight: bold;
          }

          .language-flag {
            width: 20px;
            height: 14px;
            object-fit: contain;
          }
        `}
      </style>

      <div className="language-switcher">
        <button
          className={`language-button ${currentLang === "fr" ? "active" : ""}`}
          onClick={() => changeLanguage("fr")}
        >
          <img
            className="language-flag"
            src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1eb-1f1f7.svg"
            alt="FR"
          />
          <span></span>
        </button>
        <button
          className={`language-button ${currentLang === "ar" ? "active" : ""}`}
          onClick={() => changeLanguage("ar")}
        >
          <img
            className="language-flag"
            src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f2-1f1e6.svg"
            alt="MA"
          />
          <span></span>
        </button>
      </div>
    </>
  );
};

export default LanguageSwitcher;